// errors
const INVALID_CREDENTIALS = 'Request failed with status code 401'
const EMAIL_NOT_CONFIRMED = 'GraphQL error: Email not confirmed'
const USER_ALREADY_EXISTS = 'GraphQL error: User already exists'
const INVALID_PASSWORD = 'GraphQL error: Invalid password'

// answer
const WRONG_EMAIL_OR_PASSWORD_MESSAGE = 'Wrong email or password'
const TRY_AGAIN_MESSAGE = 'An error occurred, please try again later'
const CHECK_EMAIL_MESSAGE = 'Email not confirmed, please check your email'
const USER_ALREADY_EXISTS_MESSAGE = 'User already exists'
const INVALID_PASSWORD_MESSAGE = 'Wrong Password'


export const errorAuthHandler = (message) => {
    if (message === INVALID_CREDENTIALS) {
        return WRONG_EMAIL_OR_PASSWORD_MESSAGE
    }
    return TRY_AGAIN_MESSAGE
}
